import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import FormActionButtons from '../../../../Shared/FormAction/FormActionButtons';
import { useNavigate } from 'react-router-dom';
import { Form, Schema } from 'rsuite';
import renewalService from '../../../../../services/Internal/Renewal/renewal.service';
import violationService from '../../../../../services/Internal/Renewal/PLS/violation.service';
import { useSelector } from 'react-redux';
import Information from '../../../../Shared/Card/Information';
import { GetRenewalInformationContent } from '../../../../Shared/InformationContent/PlsInformation';
import entityService from '../../../../../services/Internal/Staff/entity.service';
import LoadingSpinner from '../../../../Shared/GenericComponents/LoadingSpinner';
import Issues from '../../../../Shared/Card/Issues';
import { getRenewalCodeViolationAnswers } from '../../../../../services/Shared/codeTable.service';
import GenericViolations from '../../../../Shared/Card/Violations';
import FormEntityInformation from '../../../Shared/FormEntityInformation';

function Violations() {

    const [hasLoaded, setHasLoaded] = useState(false);
    const [isComplete, isCompleteCallBack] = useState(false);
    const [isUserEditable, setIsUserEditable] = useState(true);
    const [sectionData, setSectionData] = useState({});
    const routes = useSelector(x => x.currentRoutes);
    const push = useNavigate();
    const sectionId = 4;
    const renewalId = useSelector(x => x.currentApplicationId);
    const entityId = useSelector(x => x.userInfo.EntityId)
    const [entityInfo, setEntityInfo] = useState(
        {
            lolaNum: null,
            entityName: '',
            licenseNumber: '',
            formType: "Professional Land Surveyor Renewal",
            isIndividual: true,
            entityId: 0,
            applicationDate: "",
            currentSection: "Violations"
        }
    );

    const [formData, updateFormData] = useState({
        renewalId: renewalId,
        dateCrte: new Date(),
        entityId: entityId,
        id: 0,
        question1: null,
        userCrte: "",
        yesAnswerExplanation: ""
    });

    useEffect(() => {
        setHasLoaded(false);
        renewalService.plsGetSection(renewalId, sectionId).then((response) => {
            violationService.getViolation(renewalId).then((data) => {
                if (data.data) {

                    updateFormData(data.data);
                }
                else {
                    getRenewalCodeViolationAnswers(5).then((questions) => {
                        updateFormData({ ...formData, answers: [...questions] })
                    })
                }
                setSectionData(response.data);
                isCompleteCallBack(response.data.staffReviewComplete)
                renewalService.getIndividualRenewal(renewalId).then((renewalData) => {
                    setIsUserEditable(renewalData.data.status.id == 2)
                    entityService.getEntity(response.data.entityId).then((entity) => {
                        setEntityInfo(
                            {
                                ...entityInfo,
                                lolaNum: entity.data.lolaNumber,
                                entityName: entity.data.formattedName,
                                entityId: entity.data.entityId,
                                licenseNumber: renewalData.data?.credential?.formattedLicenseNumber,
                                applicationDate: renewalData.data?.dateSubmitted
                            })
                        setHasLoaded(true);
                    });
                });
            })
        })

    }, [])

    const showAdditionalFields = formData?.answers?.findIndex(x => x.answer == true) >= 0;
    const [showFormErrors, setShowFormErrors] = useState(false);
    const { StringType } = Schema.Types;
    const model = Schema.Model({
        yesAnswerExplanation: StringType().when(schema => {
            return showAdditionalFields ? StringType().isRequired('This field is required.') : StringType();
        })
    });




    const handleSubmit = (val, event) => {
        if (!isUserEditable) {
            push(routes[routes.findIndex(el => { if (el.sectionId == sectionId) { return true; } }) + 1].route)
        }
        else {
            setShowFormErrors(true)
            var validationObject = model.check(formData);
            for (const key in validationObject) {
                if (validationObject[key].hasError && (!key.includes("yesAnswerExplanation") || (showAdditionalFields && key.includes("yesAnswerExplanation")))) {
                    return;
                }

            }
            if (formData?.answers?.findIndex(x => x.answer !== true && x.answer !== false) >= 0) {//undefined check
                return;
            }
            violationService.postViolation(formData).then((response) => {
                if (response.data.id) {
                    renewalService.plsMarkSectionComplete(renewalId, sectionId, isComplete).then((data) => {
                        push(routes.filter(x => x.sectionId == (sectionId + 2))[0].route)
                    })
                }
            })
        }
    }



    return (
        <div className="plsRenewalViolationsPage">
            <Container fluid>
                <FormEntityInformation {...entityInfo} />
                <Information content={GetRenewalInformationContent("violations")} />
                <br />
                {hasLoaded ?
                    <Form model={model} onSubmit={handleSubmit} onChange={updateFormData} fluid formValue={formData}>
                        <GenericViolations
                            showFormErrors={showFormErrors}
                            showAdditionalFields={showAdditionalFields}
                            hideSignature={true}
                            isReadOnly={!isUserEditable}
                            isInternal={true}
                            sectionId={sectionId}
                            sectionDataId={sectionData.id}
                            entityId={entityInfo.entityId}
                            parentTypeId={3}
                            credentialTypeId={5}
                        />
                        <br />
                        <Issues isUserEditable={isUserEditable} isInternal={true} type={3} sectionId={sectionData.id} setIsComplete={isCompleteCallBack} />
                        <FormActionButtons
                            isUserEditable={isUserEditable}
                            showSectionComplete={true}
                            isComplete={isComplete}
                            isCompleteCallback={isCompleteCallBack}
                            backToSectionLink="/internal/plsRenewal/sections" />
                    </Form> : <LoadingSpinner />
                }
            </Container>
        </div>
    )
}
export default Violations;